import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, small: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'a',
    small: false,
};

class Loader extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            small,
        } = this.props;
        return [
            's-loader',
            small ? 's-loader_size_small' : false,
            className,
        ];
    }

    renderChildren() {
        return (
            <>
                <div className="s-loader__round" />
                <div className="s-loader__border" />
            </>
        );
    }

}

Loader.propTypes = propTypes;

Loader.defaultProps = defaultProps;

export default Loader;
